"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * caclulate the standard deviation of an array of values
 *
 * @param  {number[]} values
 * @returns number
 */
function standardDeviation(values) {
    if (values.length === 0) {
        return 0;
    }
    var avg = average(values);
    var squareDiffs = values.map(function (value) {
        var diff = value - avg;
        var sqrDiff = diff * diff;
        return sqrDiff;
    });
    var avgSquareDiff = average(squareDiffs);
    var stdDev = Math.sqrt(avgSquareDiff);
    return stdDev;
}
exports.standardDeviation = standardDeviation;
/**
 * calculate the average of an array of numbers
 *
 * @param  {number[]} data
 * @returns number
 */
function average(data) {
    if (data.length === 0) {
        return 0;
    }
    var sum = data.reduce(function (sum, value) {
        return sum + value;
    }, 0);
    var avg = sum / data.length;
    return avg;
}
exports.average = average;
/**
 * calculate the derivative using a sliding window of 2 values
 *
 * @param  {number[]} data
 * @returns number[]
 */
function derivative(data) {
    var d1 = [];
    for (var i = 0; i < data.length; i++) {
        if (i === 0) {
            d1[i] = 0;
        }
        else {
            d1[i] = (data[i] - data[i - 1]);
        }
    }
    return d1;
}
exports.derivative = derivative;
/**
 * calculate the standard deviation of a specified section of data
 *
 * @param  {number[]} data - array of values
 * @param  {number} startIndex - index to start calculations (inclusive)
 * @param  {number} endIndex - index to stop calculations (exclusive)
 * @returns number
 */
function stdDevOfRange(data, startIndex, endIndex) {
    var filteredData = data.slice(startIndex, endIndex);
    return standardDeviation(filteredData);
}
exports.stdDevOfRange = stdDevOfRange;
/**
 * calculate the average of a specified section of data
 *
 * @param  {number[]} data - array of values
 * @param  {number} startIndex - index to start calculations (inclusive)
 * @param  {number} endIndex - index to stop calculations (exclusive)
 * @returns number
 */
function avgOfRange(data, startIndex, endIndex) {
    var filteredData = data.slice(startIndex, endIndex);
    return average(filteredData);
}
exports.avgOfRange = avgOfRange;
/**
 * convert an array of numbers to there absolute values
 *
 * @param  {number[]} data
 * @returns number[]
 */
function absoluteValues(data) {
    return data.map(function (v) {
        if (v < 0) {
            return v * -1;
        }
        else {
            return v;
        }
    });
}
exports.absoluteValues = absoluteValues;
/**
 * calculate the integral of an array of numbers
 *
 * @param  {number[]} data
 * @returns number
 */
function integral(data) {
    var integral = 0;
    for (var i = 1; i < data.length; i++) {
        integral = integral + 1 * ((data[i - 1] + data[i]) / 2);
    }
    return integral;
}
exports.integral = integral;
